import { useState, useEffect } from 'react';
import { useToast } from '../../contexts/ToastContext';
import FilterBar from '../FilterBar';
import ReceiptsTable from './ReceiptsTable';

/**
 * Composant onglet Liste des frais - Affiche les frais scannés avec filtres
 */
function ReceiptsListTab() {
  const { showToast } = useToast();

  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterYear, setFilterYear] = useState(null);
  const [filterMonth, setFilterMonth] = useState(null);

  // Options pour les filtres
  const currentYear = new Date().getFullYear();
  const yearOptions = [
    { value: currentYear, label: currentYear.toString() },
    { value: currentYear - 1, label: (currentYear - 1).toString() },
    { value: currentYear - 2, label: (currentYear - 2).toString() },
  ];

  const monthOptions = [
    { value: 1, label: 'Janvier' },
    { value: 2, label: 'Février' },
    { value: 3, label: 'Mars' },
    { value: 4, label: 'Avril' },
    { value: 5, label: 'Mai' },
    { value: 6, label: 'Juin' },
    { value: 7, label: 'Juillet' },
    { value: 8, label: 'Août' },
    { value: 9, label: 'Septembre' },
    { value: 10, label: 'Octobre' },
    { value: 11, label: 'Novembre' },
    { value: 12, label: 'Décembre' },
  ];

  const loadReceipts = async () => {
    setLoading(true);
    try {
      const response = await fetch('/.netlify/functions/getScannedReceipts', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
        }
      });

      if (!response.ok) {
        throw new Error('Erreur lors du chargement des frais');
      }

      const data = await response.json();
      setReceipts(data.receipts || []);
    } catch (error) {
      console.error('Erreur chargement frais:', error);
      showToast(error.message || 'Erreur lors du chargement des frais', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReceipts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Filtrer les reçus
  const filteredReceipts = receipts.filter(receipt => {
    if (!receipt.date) return false;

    const receiptDate = new Date(receipt.date);
    const receiptYear = receiptDate.getFullYear();
    const receiptMonth = receiptDate.getMonth() + 1;

    if (filterYear && receiptYear !== filterYear) return false;
    if (filterMonth && receiptMonth !== filterMonth) return false;

    return true;
  });

  const styles = {
    container: {
      padding: '0 2rem',
      maxWidth: '1400px',
      margin: '0 auto',
    },
  };

  const filters = [
    {
      type: 'select',
      label: 'Année',
      value: filterYear,
      onChange: setFilterYear,
      options: yearOptions,
      placeholder: 'Toutes les années',
      minWidth: '180px',
      allowNull: true
    },
    {
      type: 'select',
      label: 'Mois',
      value: filterMonth,
      onChange: setFilterMonth,
      options: monthOptions,
      placeholder: 'Tous les mois',
      minWidth: '180px',
      allowNull: true
    }
  ];

  const resultCount = (
    <span>
      {filteredReceipts.length} frais trouvé{filteredReceipts.length > 1 ? 's' : ''}
    </span>
  );

  return (
    <div style={styles.container}>
      <FilterBar
        filters={filters}
        resultCount={resultCount}
      />

      <ReceiptsTable
        receipts={filteredReceipts}
        loading={loading}
      />
    </div>
  );
}

export default ReceiptsListTab;
